import { apiClient } from './api';
import type { Notice, UnreadCountResponse, MarkReadResponse } from '../types/notices';

// API response wrapper type
interface ApiResponse<T> {
  data: T;
  meta?: Record<string, any>;
  status: 'success' | 'error';
}

export const noticesService = {
  /**
   * Fetch all active notices with read status.
   */
  async getNotices(): Promise<Notice[]> {
    const response = await apiClient.get<ApiResponse<Notice[]>>('/api/announcements/');
    return response.data;
  },

  /**
   * Get count of unread notices.
   */
  async getUnreadCount(): Promise<UnreadCountResponse> {
    const response = await apiClient.get<ApiResponse<UnreadCountResponse>>('/api/announcements/unread-count/');
    return response.data;
  },

  /**
   * Mark a single notice as read.
   */
  async markAsRead(noticeId: number): Promise<MarkReadResponse> {
    const response = await apiClient.post<ApiResponse<MarkReadResponse>>(`/api/announcements/${noticeId}/read/`);
    return response.data;
  },

  /**
   * Mark all notices as read.
   */
  async markAllAsRead(): Promise<MarkReadResponse> {
    const response = await apiClient.post<ApiResponse<MarkReadResponse>>('/api/announcements/mark-all-read/');
    return response.data;
  },
};
